__turbopack_context__.v({
  "footer": "styles-module__CXSKEq__footer",
});
